import React, { useEffect, useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper";
import type { Swiper as SwiperType } from "swiper";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "./slider.scss";
import { SliderPropsType } from "./types";

interface SliderProps extends SliderPropsType {
  onImageClick?: (image: string) => void;
}

export const Slider: React.FC<SliderProps> = ({ 
  images, 
  onImageClick, 
  selectedIndex = 0,
  onSlideChange 
}) => {
  const swiperRef = useRef<SwiperType | null>(null);

  useEffect(() => {
    if (swiperRef.current && selectedIndex !== undefined) {
      swiperRef.current.slideTo(selectedIndex);
    }
  }, [selectedIndex]);

  const handleImageClick = (image: string) => {
    if (onImageClick) {
      onImageClick(image);
    }
  };

  const handleSlideChange = (swiper: SwiperType) => {
    if (onSlideChange) {
      onSlideChange(swiper.activeIndex);
    }
  };

  return (
    <Swiper
      modules={[Navigation, Pagination]}
      spaceBetween={10}
      slidesPerView={1}
      speed={500}
      navigation
      pagination={{
        clickable: true,
        dynamicBullets: true,
      }}
      className="slider"
      initialSlide={selectedIndex}
      onSwiper={(swiper) => {
        swiperRef.current = swiper;
      }}
      onSlideChange={handleSlideChange}
    >
      {images.map((image: string, i: number) => (
        <SwiperSlide key={i}>
          <img
            src={image}
            alt="club's foto"
            loading={i === 0 ? "eager" : "lazy"}
            onClick={() => handleImageClick(image)}
          />
        </SwiperSlide>
      ))}
    </Swiper>
  );
};
